import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import OrgProfile from "@/pages/OrgProfile";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import Verification from "@/pages/Verification";
import ForCSR from "@/pages/ForCSR";
import ForNGOs from "@/pages/ForNGOs";
import Faq from "@/pages/Faq";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import NGODashboard from "@/pages/NGODashboard";
import CSRWorkspace from "@/pages/CSRWorkspace";
import AdminConsole from "@/pages/AdminConsole";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/ngo/:id" element={<OrgProfile />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/stories/:slug" element={<StoryDetail />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/for-csr" element={<ForCSR />} />
          <Route path="/for-ngos" element={<ForNGOs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/ngo/dashboard" element={<ProtectedRoute roles={["ngo_admin", "admin"]}><NGODashboard /></ProtectedRoute>} />
          <Route path="/csr/workspace" element={<ProtectedRoute roles={["csr_manager", "admin"]}><CSRWorkspace /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminConsole /></ProtectedRoute>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
